module.exports = __webpack_public_path__ + "static/media/jazz_audio.84692dfa.mp4";